import { visit } from 'unist-util-visit';

import CoreBase from '../../../../../services/engines/CoreBase';
import { isTreeBlockText, parseTreeBlock } from './sourceTreeParser';
import { extractParagraphText } from '../mdastText';

/**
 * Detects Jerny Source-index tree diagrams inside markdown paragraphs (e.g. ├── file.cs ← comment)
 * and rewrites them into a custom hast node so MarkdownRenderer can render them as boxed rows.
 * Singleton — shared across all MarkdownRenderer instances.
 */
class SourceTreeFormatter extends CoreBase {
    _name = 'SourceTreeFormatter';

    /**
     * Returns a remark plugin that converts tree-diagram paragraphs into 'sourcetreeblock' nodes.
     * @returns {Function} remark plugin
     */
    createRemarkPlugin = () => {
        return () => (tree) => {
            visit(tree, 'paragraph', this._visitParagraphNode);
        };
    };

    // ─── private ──────────────────────────────────────────

    /**
     * Visits a paragraph node — if its raw text looks like a tree diagram,
     * replaces it with a custom hast element carrying the parsed rows.
     * @param {object} node - mdast paragraph node
     */
    _visitParagraphNode = (node) => {
        try {
            const rawText = extractParagraphText(node);
            if (!isTreeBlockText(rawText)) return;

            const rows = parseTreeBlock(rawText);
            node.children = [];
            node.data = { hName: 'sourcetreeblock', hProperties: { 'data-rows': JSON.stringify(rows) } };
        } catch (error) {
            this.logError('_visitParagraphNode', error.message);
        }
    };

}

const sourceTreeFormatter = new SourceTreeFormatter();
export default sourceTreeFormatter;
